import PanelTravelAdvance from '../PanelTravelAdvance/PanelTravelAdvance.vue'
import FormDetailsAdvance from '../FormDetailsAdvance/FormDetailsAdvance.vue'
export default {
  name: 'DetailsTravelAdvanced',
  props: ['dataDetails', 'logRefresh'],
  components: {PanelTravelAdvance, FormDetailsAdvance},
  data () {
    return {
      Situacao: null
    }
  },

  methods: {
    refreshLogAdvance () {
      this.$refs.FormDetailsAdvance.GetLogById()
    },
    carregaSituacao (value) {
      this.Situacao = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/DetailsTravelAdvanced/DetailsTravelAdvanced.js